
import { Options, Vue, Watch } from "vue-property-decorator";
import { Router } from "vue-router";
import { IBreadcrumb } from "@/interfaces/IBreadcrumb";
import { isArray } from "lodash";

@Options({
  components: {},
})
export default class Breadcrumbs extends Vue {
  private breadcrumbs: Array<IBreadcrumb> = [];

  @Watch("$route", { immediate: true, deep: true })
  protected routeChanged(router: Router) {
    const title = this.$route?.meta?.title
      ? String(this.$route.meta.title)
      : "";
    this.breadcrumbs = isArray(this.$route.meta.breadcrumbs)
      ? this.$route.meta.breadcrumbs
      : [];
  }
}
